export default __webpack_public_path__ + "static/media/gatwick-airport-logo.d4a70866.svg";